import { render, staticRenderFns } from "./DialogDone.vue?vue&type=template&id=c4901ee2&scoped=true&"
import script from "./DialogDone.vue?vue&type=script&lang=js&"
export * from "./DialogDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4901ee2",
  null
  
)

export default component.exports